import React from 'react';
import { ClipboardCheck, Search, UserCheck, Home } from 'lucide-react';

interface Step {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const ADOPTION_STEPS: Step[] = [
  {
    icon: <Search className="w-[3em] h-[3em] text-accessible-red-600" />,
    title: "Zadzwoń do nas",
    description: "Pierwszy krok to rozmowa telefoniczna. Opowiedz nam o swoich oczekiwaniach i warunkach, jakie możesz zapewnić."
  },
  {
    icon: <ClipboardCheck className="w-[3em] h-[3em] text-accessible-red-600" />,
    title: "Spotkaj się ze zwierzakiem",
    description: "Przyjedź do nas lub domu tymczasowego, aby osobiście poznać wybranego pupila."
  },
  {
    icon: <UserCheck className="w-[3em] h-[3em] text-accessible-red-600" />,
    title: "Wizyta przedadopcyjna",
    description: "Przyjmiemy wolontariusza, który pomoże przygotować dom na przyjęcie nowego członka rodziny."
  },
  {
    icon: <Home className="w-[3em] h-[3em] text-accessible-red-600" />,
    title: "Podpisz umowę",
    description: "Ostatni krok to podpisanie umowy adopcyjnej i powitanie nowego członka rodziny."
  }
];

export function AdoptionProcess() {
  return (
    <section className="py-24 px-12 bg-primary/5 dark:bg-primary/20 high-contrast:bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">
            Proces adopcji
          </h2>
          <p className="body-large">
            Poznaj kroki do adopcji nowego przyjaciela
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {ADOPTION_STEPS.map((step, index) => (
            <div 
              key={index} 
              className="text-center transform hover:scale-105 transition-transform duration-300 group"
              title={`Krok ${index + 1}: ${step.title}`}
            >
              <div className="mb-6 flex justify-center">
                <div className="w-20 h-20 rounded-full bg-accessible-red-600/10 flex items-center justify-center group-hover:bg-accessible-red-600/20 transition-colors">
                  <span aria-hidden="true">{step.icon}</span>
                </div>
              </div>
              <h3 className="card-title mb-2 text-accessible-gray-900 dark:text-white high-contrast:text-white">
                {step.title}
              </h3>
              <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}